import { useState, useEffect, useRef } from "react"
import { Link, useLocation } from "react-router-dom"
import { Button } from "react-bootstrap"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { StringInput, ImageInputNew } from "@/components/common/formElements"
import {
  IconAlertCircle,
  IconArrowLeft,
} from "../../../components/utils/Icons/CustomIcons"
import { FaCaretRight } from "react-icons/fa6"
import { useAppDispatch, useAppSelector } from "../../../redux/store"
import moment from "moment"
import Modal from "react-bootstrap/Modal"
import { useTranslation } from "react-i18next"
import { useForm, FormProvider, SubmitHandler } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import { z } from "zod"
import { zodResolver } from "@hookform/resolvers/zod"
import { MdLock } from "react-icons/md"
import { MdClose } from "react-icons/md"
import Switch from "react-switch"
import styles from "./addInvite.module.scss"
import InvitesmartLogonew from "@/assets/images/invitesmartLogoneww.png"
import Spinner from "react-bootstrap/Spinner"
import chooseTypeNumber from "@/assets/images/chooseType.png"
import chooseTypeName from "@/assets/images/chooseTypeName.png"
import { ToastContainer, toast, Slide } from "react-toastify"
import api from "@/api/api"
import Loader from "../../../Loader"
import LoaderLight from "../../../LoaderLight"
import { authentication } from "@/redux/slices/auth/authSlice"
import { ColorPicker } from "../displayColor"
import { ColorPickerQrCode } from "../displayColorQrCode"
import { ColorPickerPremium } from "../displayColorPremium"
import DisabledColors from "../disabledColors"
import QRGenerator from "../generateQrCode"
import { RgbToHex } from "../displayColor"
import { FontPicker } from "../fontPicker"
import { FontPickerPremium } from "../fontPickerPremium"
import { FontPickerUnPremium } from "../fontPickerUnPremium"
import { ColorPickerUnPremium } from "../displayColorUnPremium"
import { getBalance } from "@/redux/slices/balance/balanceSlice"
import NameLabel from "../nameLabelDevelopment"
import { QRSizeModal } from "./changeQrSizeModal" // Import the extracted component
import { NameOrNumberSizeModal } from "./changeNameOrNumberSizeModal"
import { UpgradeToPremiumPopup } from "./upgradeToPremium"
import { AddGuestsForNumberModal } from "./addGuestForNumber"

type addInviteType = {
  setActivePage: (step: string) => void
}
// Font styles array
const fonts = [
  {
    name: "NotoSans_regular",
    label: "Noto Sans",
    fontFamily: "'Noto Sans', sans-serif",
  },
  { name: "Rubik_regular", label: "Rubik", fontFamily: "'Rubik', sans-serif" },
  { name: "Amiri_regular", label: "Amiri", fontFamily: "'Amiri', serif" },
  { name: "Cairo_regular", label: "Cairo", fontFamily: "'Cairo', sans-serif" },
  {
    name: "ScheherazadeNew_regular",
    label: "Scheherazade",
    fontFamily: "'Scheherazade', serif",
  },
  {
    name: "MarkaziText_regular",
    label: "Markazi",
    fontFamily: "'Markazi Text', serif",
  },

  { name: "Lora_regular", label: "Lora", fontFamily: "'Lora', serif" },
  {
    name: "Montserrat_regular",
    label: "Montserrat",
    fontFamily: "'Montserrat', sans-serif",
  },
]

// In your main component file

// Add this state to control the modal

const findLatestEntitlement = (entitlements: any) => {
  const now = new Date() // Current date and time
  const entitlementList = Object.values(entitlements)
  // Filter entitlements to only include those that have not expired
  const activeEntitlements = entitlementList.filter((entitlement: any) => {
    return new Date(entitlement.expires_date) > now
  })

  // If no active entitlements, return null or handle appropriately
  if (activeEntitlements.length === 0) return null

  // Find the latest entitlement based on purchase_date
  return activeEntitlements.reduce((latest: any, current: any) => {
    return new Date(current.purchase_date) > new Date(latest.purchase_date)
      ? current
      : latest
  })
}

const AddInvitationFrom = ({ setActivePage }: addInviteType) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const {
    inviteName,

    // qrPosition,
    qrCodeDesignResponse,
    inviteImageBinary,
    currentCreatedEvent,
  } = useAppSelector((state) => state.invite)
  // testststs
  const uploadedImageRef = useRef<HTMLImageElement | null>(null)
  const { isSubscriptionLoading, entitlements, currentPovPlan } =
    useAppSelector((state) => state.payments)
  const { isLoading, email, phone, first_name, last_name } = useAppSelector(
    (state) => state?.auth,
  )
  const { lang, error } = useAppSelector((state) => state.auth)

  ///bvasic and control/
  const [active, setActive] = useState("eventFrom")
  const [premium, setPremium] = useState(0)
  const [currentEventCreated, setCurrentEventCreated] = useState<any>(null)
  const [currentImageUrl, setCurrentImageUrl] = useState<any>(null)
  // const [loadingPremium, setLoadingPremium] = useState(false)

  const [upgrade, setUpgrade] = useState(false)
  const [upgradesText, setUpgradeText] = useState("")
  const [loading, setLoading] = useState(false)
  const [totalData, setTotalData] = useState<any>(null)
  const [namesInput, setNamesInput] = useState<string>("")
  const [numberOfGuests, setNumberOfGuests] = useState<number>(1)

  const [imageId, setImageId] = useState(0) // [setImage
  const [eventId, setEventId] = useState(0)
  ///name or nummber choice
  const [chooseType, setChooseType] = useState("number")
  ///add guests modalds
  const [showCreateModal, setShowCreateModal] = useState(false)

  ////
  ///font and color for qrCode and name
  const [colors, setColors] = useState<string[]>([])
  const [selectedColor, setSelectedColor] = useState<string>("rgb(0,0,0)")
  const [selectedColorName, setSelectedColorName] =
    useState<string>("rgb(0,0,0)")
  const [selectedFont, setSelectedFont] = useState<any>(fonts[0])
  const [numberOutSideToggle, setNumberOutSideToggle] = useState(false)
  const [toggleRemoveLogo, setToggleRemoveLogo] = useState(false)
  /////color for name

  // drag and drop feature for qrsize and logo
  const [qrValue, setQrValue] = useState<string>("Hello")
  const [imageContainerWidth, setImageContainerWidth] = useState(300)
  const [imageContainerHeight, setImageContainerHeight] = useState(300)

  //////
  const [qrPosition, setQrPosition] = useState({ x: 20, y: 5 })

  const [logoPosition, setLogoPosition] = useState({
    x: 90,
    y: 5,
  })
  const [showQrSize, setShowQrSize] = useState(false)
  const [qrSize, setQrSize] = useState(50)
  // name size and position
  const [showNameSize, setShowNameSize] = useState(false)
  const [nameSize, setNameSize] = useState(14)
  const [namePosition, setNamePosition] = useState({
    x: 20,
    y: 50,
  })

  // const uploadedImageRef = useRef<HTMLImageElement | null>(null)
  const qrDivRef = useRef<HTMLDivElement | null>(null)
  const logoDivRef = useRef<HTMLImageElement | null>(null)
  const nameDivRef = useRef<HTMLDivElement | null>(null)
  const nameLabelRef = useRef<HTMLDivElement>(null)
  const [width, setWidth] = useState<number>(0)

  const eventSchema = z.object({
    image: z
      .any()
      .refine((files) => files && files.length > 0, {
        message: t("event.formSchemas.imageIsRequired"),
      })
      .refine(
        (files) => {
          if (!files || files.length === 0) return true // Skip if no file is provided
          const file = files[0] // Since multiple is false, only one file is expected
          const validTypes = ["image/jpeg", "image/png", "image/jpg"]
          return validTypes.includes(file?.type)
        },
        {
          message: "Allowed formats are JPG, PNG, JPEG.",
        },
      )
      .refine(
        (files) => {
          if (!files || files.length === 0) return true // Skip if no file is provided
          const file = files[0]
          return file?.size <= 5 * 1024 * 1024 // 5MB size limit
        },
        {
          message: "Image size should be less than 5 MB.",
        },
      ),
    // eventName: z.string().min(1, "Event name is required"),
    eventName: z.string().min(1, t("event.formSchemas.invitationTextRequired")),
  })

  type EventFormData = z.infer<typeof eventSchema>
  const methods = useForm<any>({
    resolver: zodResolver(eventSchema),
  })
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = methods

  const formValues = watch()
  // drag and drop
  /////set  if the ueer if active oj the tab or not
  const [isTabActive, setIsTabActive] = useState(true)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        setIsTabActive(true) // User returned to the tab
      } else {
        setIsTabActive(false) // User left the tab
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [])
  // Calculate the scaling factors for the image based on container dimensions

  useEffect(() => {
    try {
      if (formValues?.image && formValues.image[0]) {
        const urlImage = URL.createObjectURL(formValues.image[0])
        setCurrentImageUrl(urlImage)
      }
    } catch (err) {
      console.log("Error", err)
      console.error("Error in creating object URL", err)
    }

    // Cleanup function to revoke the object URL when the component unmounts or the image changes
    return () => {
      if (currentImageUrl) {
        URL.revokeObjectURL(currentImageUrl)
      }
    }
  }, [formValues?.image]) // Only re-run when formValues.image change
  // Ensure the ref is attached to an element before accessing its properties
  useEffect(() => {
    // Ensure the ref is attached to an element before accessing its properties
    if (uploadedImageRef.current) {
      const width = uploadedImageRef.current.offsetWidth
      const height = uploadedImageRef.current.offsetHeight
      setImageContainerWidth(width)
      setImageContainerHeight(height)
      setQrPosition({ x: 20, y: 5 })
      setLogoPosition({
        // x: 70,
        x: (uploadedImageRef.current.offsetWidth * 80) / 100,
        y: 5,
      })
      setNamePosition({
        x: 22,
        y: 60,
      })
      setQrSize(50)
      setNameSize(14)
    }
  }, [uploadedImageRef.current, formValues?.image])

  const handleSetImageRef = (ref: any) => {
    try {
      // uploadedImageRef.current = ref
      // setImageContainerWidth(ref?.naturalWidth)
      // setImageContainerHeight(ref?.naturalHeight)

      ref.onload = () => {
        if (uploadedImageRef.current) {
          setQrPosition({ x: 20, y: 5 })
          const width = uploadedImageRef.current.offsetWidth
          const height = uploadedImageRef.current.offsetHeight
          setImageContainerWidth(width)
          setImageContainerHeight(height)
          setLogoPosition({
            // x: 70,
            x: (uploadedImageRef.current.offsetWidth * 80) / 100,
            y: 5,
          })
          setQrSize(50)
          setNameSize(14)
        }
        console.log("Image width:", ref.width)
        console.log("Image height:", ref.height)
      }
    } catch (err) {
      console.log("err", err)
    }
    // if (ref) {
    //   console.log("updating the reference ")
    //   const width = ref.current.offsetWidth
    //   const height = ref.current.offsetHeight
    //   setImageContainerWidth(width)
    //   setImageContainerHeight(height)
    // }
  }
  ////////normmal susbrcritoin check account susbcription
  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const identifier = email || phone || ""
        const res = await api.payments.getPovSubscription(identifier)
        const plan: any = findLatestEntitlement(
          res?.data.subscriber?.entitlements,
        )
        if (
          plan?.product_identifier == "pro_plan" ||
          plan?.product_identifier == "unlimited_plan"
        ) {
          setPremium(1)
        } else {
          // setPremium(0)
        }
      } catch (error) {
        console.error("Error fetching subscription:", error)
      }
    }

    fetchSubscription()
  }, [email, phone])
  //////check the subscription  for invitemsart subscription
  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        dispatch(authentication(null))
          .then((data) => {
            if (
              data?.payload?.invitesmart_subscription &&
              data?.payload?.invitesmart_subscription != "basic"
            ) {
              setPremium(1)
            }
          })
          .catch((error) => {})
      } catch (error) {
        console.error("Error fetching subscription:", error)
      }
    }

    fetchSubscription()
  }, [])
  ////check event status ever three second
  useEffect(() => {
    const checkEventStatus = async (eventId: string | number) => {
      try {
        const res = await api.events.checkEventStatus(eventId)
        if (premium == 0 && res?.data?.isPremium == 1) {
          toast.success("Event upgraded successfully", {
            position: "top-right",
            transition: Slide,
            autoClose: 2000, // 3 seconds
            closeButton: false, // Removes the close button
          })
          if (res?.data?.isPremium == 1) {
            setPremium(1)
          }
        } else {
          if (res?.data?.isPremium == 1) {
            setPremium(1)
          }
        }
        console.log("res for event status", res?.data?.isPremium)
      } catch (error) {
        console.error("Error fetching subscription:", error)
      }
    }
    if (currentEventCreated && currentEventCreated !== null)
      checkEventStatus(currentEventCreated?.event_id)
  }, [isTabActive])

  const handleCloseCreateModal = () => {
    setShowCreateModal(false)
  }
  const handleSetColors = (extractedColors: string[]) => {
    setColors(extractedColors)
  }
  const handleChangeLogoRemoval = () => {
    if (!formValues?.eventName) {
      // toast.error(t("invitation.pleaseFillInvitationNameFirst"))
      toast.error(t("invitation.pleaseFillInvitationNameFirst"), {
        position: "top-right",
        transition: Slide,
        autoClose: 2000, // 3 seconds
        closeButton: false, // Removes the close button
      })
      return
    }

    if (formValues?.image?.length < 1) {
      toast.error(t("invitation.pleaseSelectImageFirst"), {
        position: "top-right",
        transition: Slide,
        autoClose: 2000, // 3 seconds
        closeButton: false, // Removes the close button
      })
      return
    }
    if (premium != 1) {
      setUpgradeText("logo_removal")
      setUpgrade(true)
    } else {
      setToggleRemoveLogo(!toggleRemoveLogo)
    }
  }

  const handleChangeFont = () => {
    if (!formValues?.eventName) {
      // toast.error(t("invitation.pleaseFillInvitationNameFirst"))
      toast.error(t("invitation.pleaseFillInvitationNameFirst"), {
        position: "top-right",
        transition: Slide,
        autoClose: 2000, // 3 seconds
        closeButton: false, // Removes the close button
      })
      return
    }

    if (formValues?.image?.length < 1) {
      toast.error(t("invitation.pleaseSelectImageFirst"), {
        position: "top-right",
        transition: Slide,
        autoClose: 2000, // 3 seconds
        closeButton: false, // Removes the close button
      })
      return
    }
    if (premium != 1) {
      setUpgradeText("fonts")
      setUpgrade(true)
    } else {
    }
  }

  const handleChangeColor = () => {
    if (!formValues?.eventName) {
      // toast.error(t("invitation.pleaseFillInvitationNameFirst"))
      toast.error(t("invitation.pleaseFillInvitationNameFirst"), {
        position: "top-right",
        transition: Slide,
        autoClose: 2000, // 3 seconds
        closeButton: false, // Removes the close button
      })
      return
    }

    if (formValues?.image?.length < 1) {
      toast.error(t("invitation.pleaseSelectImageFirst"), {
        position: "top-right",
        transition: Slide,
        autoClose: 2000, // 3 seconds
        closeButton: false, // Removes the close button
      })
      return
    }
    if (premium != 1) {
      setUpgradeText("colors")
      setUpgrade(true)
    }
  }
  /////qr positions
  const handleDragStart = (event: React.DragEvent<HTMLImageElement>) => {
    event.dataTransfer.setDragImage(new Image(), 0, 0)
  }

  const handleDrag = (event: React.DragEvent<HTMLImageElement>) => {
    // Prevent default drag behavior
    event.preventDefault()

    if (!uploadedImageRef.current) return
    if (!qrDivRef?.current) return
    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    // Calculate the new position of the QR code during dragging
    const newX = Math.min(
      Math.max(
        event.clientX - parentRect.left - qrDivRef?.current.offsetWidth / 2,
        0,
      ), // Center the QR image (half its width)
      parentRect.width - qrDivRef?.current?.offsetWidth, // Ensure it stays within bounds
    )
    const newY = Math.min(
      Math.max(
        event.clientY - parentRect.top - qrDivRef?.current?.offsetHeight / 2,
        0,
      ),
      parentRect.height - qrDivRef?.current?.offsetHeight,
    )

    setQrPosition({ x: newX, y: newY })
  }

  const handleDragEnd = (event: React.DragEvent<HTMLImageElement>) => {
    if (!uploadedImageRef.current) return
    if (!qrDivRef?.current) return
    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    // Calculate the new position of the QR code during dragging
    const finalX = Math.min(
      Math.max(
        event.clientX - parentRect.left - qrDivRef?.current.offsetWidth / 2,
        0,
      ), // Center the QR image (half its width)
      parentRect.width - qrDivRef?.current?.offsetWidth, // Ensure it stays within bounds
    )
    const finalY = Math.min(
      Math.max(
        event.clientY - parentRect.top - qrDivRef?.current?.offsetHeight / 2,
        0,
      ),
      parentRect.height - qrDivRef?.current?.offsetHeight,
    )
    //
    // setQrPosition({ x: finalX, y: finalY })
    setQrPosition({ x: finalX, y: finalY })
  }
  const handleTouchStart = (event: React.TouchEvent<HTMLDivElement>) => {
    const touch = event.touches[0]
  }
  const handleTouchMove = (event: React.TouchEvent<HTMLDivElement>) => {
    event.preventDefault()

    if (!uploadedImageRef.current || !qrDivRef.current) return

    const touch = event.touches[0]
    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    const newX = Math.min(
      Math.max(
        touch.clientX - parentRect.left - qrDivRef.current.offsetWidth / 2,
        0,
      ),
      parentRect.width - qrDivRef.current.offsetWidth,
    )

    const newY = Math.min(
      Math.max(
        touch.clientY - parentRect.top - qrDivRef.current.offsetHeight / 2,
        0,
      ),
      parentRect.height - qrDivRef.current.offsetHeight,
    )

    setQrPosition({ x: newX, y: newY })
  }
  /////name Positions
  const handleDragStartName = (event: React.DragEvent<HTMLImageElement>) => {
    event.dataTransfer.setDragImage(new Image(), 0, 0)
  }
  const handleDragName = (event: React.DragEvent<HTMLImageElement>) => {
    // Prevent default drag behavior
    event.preventDefault()

    if (!uploadedImageRef.current) return
    if (!nameDivRef?.current) return
    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    // Calculate the new position of the QR code during dragging
    const newX = Math.min(
      Math.max(
        event.clientX - parentRect.left - nameDivRef?.current.offsetWidth / 2,
        0,
      ), // Center the QR image (half its width)
      parentRect.width - nameDivRef?.current?.offsetWidth, // Ensure it stays within bounds
    )
    const newY = Math.min(
      Math.max(
        event.clientY - parentRect.top - nameDivRef?.current?.offsetHeight / 2,
        0,
      ),
      parentRect.height - nameDivRef?.current?.offsetHeight,
    )

    setNamePosition({ x: newX, y: newY })
  }
  const handleDragEndName = (event: React.DragEvent<HTMLImageElement>) => {
    if (!uploadedImageRef.current) return
    if (!nameDivRef?.current) return
    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    // Calculate the new position of the QR code during dragging
    const finalX = Math.min(
      Math.max(
        event.clientX - parentRect.left - nameDivRef?.current.offsetWidth / 2,
        0,
      ), // Center the QR image (half its width)
      parentRect.width - nameDivRef?.current?.offsetWidth, // Ensure it stays within bounds
    )
    const finalY = Math.min(
      Math.max(
        event.clientY - parentRect.top - nameDivRef?.current?.offsetHeight / 2,
        0,
      ),
      parentRect.height - nameDivRef?.current?.offsetHeight,
    )
    //
    // setQrPosition({ x: finalX, y: finalY })
    setNamePosition({ x: finalX, y: finalY })
  }
  const handleTouchStartName = (event: React.TouchEvent<HTMLDivElement>) => {
    const touch = event.touches[0]
  }
  const handleTouchMoveName = (event: React.TouchEvent<HTMLDivElement>) => {
    event.preventDefault()

    if (!uploadedImageRef.current || !nameDivRef.current) return
    const touch = event.touches[0]
    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    const newX = Math.min(
      Math.max(
        touch.clientX - parentRect.left - nameDivRef.current.offsetWidth / 2,
        0,
      ),
      parentRect.width - nameDivRef.current.offsetWidth,
    )

    const newY = Math.min(
      Math.max(
        touch.clientY - parentRect.top - nameDivRef.current.offsetHeight / 2,
        0,
      ),
      parentRect.height - nameDivRef.current.offsetHeight,
    )

    setNamePosition({ x: newX, y: newY })
  }
  /////Logo Positions
  const handleDragStartLogo = (event: React.DragEvent<HTMLImageElement>) => {
    event.dataTransfer.setDragImage(new Image(), 0, 0)
  }
  const handleDragLogo = (event: React.DragEvent<HTMLImageElement>) => {
    // Prevent default drag behavior
    event.preventDefault()

    // if (!uploadedImageRef.current) return
    if (!logoDivRef?.current) return
    if (!uploadedImageRef.current) return
    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    // Calculate the new position of the QR code during dragging
    const newX = Math.min(
      Math.max(
        event.clientX - parentRect.left - logoDivRef?.current.offsetWidth / 2,
        0,
      ), // Center the QR image (half its width)
      parentRect.width - logoDivRef?.current?.offsetWidth, // Ensure it stays within bounds
    )
    const newY = Math.min(
      Math.max(
        event.clientY - parentRect.top - logoDivRef?.current?.offsetHeight / 2,
        0,
      ),
      parentRect.height - logoDivRef?.current?.offsetHeight,
    )

    // Temporarily update the position during drag
    setLogoPosition({ x: newX, y: newY })
  }

  const handleDragEndLogo = (event: React.DragEvent<HTMLImageElement>) => {
    if (!uploadedImageRef.current) return

    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    // Finalize the position when the drag ends

    // Calculate the new position of the QR code during dragging
    if (!uploadedImageRef.current) return
    if (!logoDivRef?.current) return
    const finalX = Math.min(
      Math.max(
        event.clientX - parentRect.left - logoDivRef?.current.offsetWidth / 2,
        0,
      ), // Center the QR image (half its width)
      parentRect.width - logoDivRef?.current?.offsetWidth, // Ensure it stays within bounds
    )
    const finalY = Math.min(
      Math.max(
        event.clientY - parentRect.top - logoDivRef?.current?.offsetHeight / 2,
        0,
      ),
      parentRect.height - logoDivRef?.current?.offsetHeight,
    )

    // setLogoPosition({ x: finalX, y: finalY })
    setLogoPosition({ x: finalX, y: finalY })
  }
  const handleTouchStartLogo = (event: React.TouchEvent<HTMLDivElement>) => {
    // Optionally store the initial touch position (if needed)
    const touch = event.touches[0]
  }

  const handleTouchMoveLogo = (event: React.TouchEvent<HTMLDivElement>) => {
    event.preventDefault() // Prevent scrolling during drag

    if (!logoDivRef?.current || !uploadedImageRef?.current) return

    const touch = event.touches[0]
    const parentRect = uploadedImageRef.current.getBoundingClientRect()

    const newX = Math.min(
      Math.max(
        touch.clientX - parentRect.left - logoDivRef.current.offsetWidth / 2,
        0,
      ),
      parentRect.width - logoDivRef.current.offsetWidth,
    )

    const newY = Math.min(
      Math.max(
        touch.clientY - parentRect.top - logoDivRef.current.offsetHeight / 2,
        0,
      ),
      parentRect.height - logoDivRef.current.offsetHeight,
    )

    // Update position during touch move
    setLogoPosition({ x: newX, y: newY })
  }
  ///submit form
  // const onSubmit: SubmitHandler<any> = async (data: any) => {
  //   // setLoading(true)
  //   setTotalData(data)
  //   setActive("activeChooseType")
  // }

  const handleSubmitForm = async () => {
    if (chooseType == "name") {
      setActive("addNames")
    } else {
      setShowCreateModal(true)
    }
  }

  const onSubmit: SubmitHandler<any> = async (data: any) => {
    // e.preventDefault()
    // if (numberOfGuests < 1) {
    //   alert("Please enter a valid number of guests greater than or equal to 1.")
    //   return // Exit the function if validation fails
    // }
    console.log("data", data)
    // return
    try {
      setLoading(true)
      const currentDate = new Date()
      // Convert the date to seconds (Unix timestamp)
      const dateInSeconds = Math.floor(currentDate.getTime() / 1000)
      // Convert the timestamp to a string
      const dateInSecondsString = dateInSeconds.toString()

      const formatDate = moment(new Date()).format("Y-MM-DD")
      const formatTime = moment(new Date()).format("HH:mm")

      const eventValues = {
        source: "invite_smart",
        guestType: chooseType,
        orientation: "v",
        name: data?.eventName,
        simplified: true,
        host_name: "host",
        event_created_date: formatDate,
        event_created_time: formatTime,
        address: {
          address: "Unknown",
          lat: "24.7136",
          lng: "46.6753",
        },
        text_style: {
          font_family: "Oxygen, sans-serif",
          font_size: "2x 1",
          font_style: {
            textBold: false,
            textItalic: false,
            textUnderline: false,
          },
          color: "#000",
          text_align: "center",
        },
        text_position: "flex-start",
        // start_datetime: dayjs
        //   .utc(totalData?.start_datetime)
        //   .format("YYYY-MM-DD HH:mm:ss"),
        venue: "",
        language: "ar",
        // type: totalData?.eventType,
        image_id: imageId, // Use the uploaded imageId here
        invitation_show_qr_code: true,
        guests_position_x: "",
        guests_position_y: "",
        guests_width_height: "",
        qr_position_x: "",
        qr_position_y: "",
        qr_width_height: "",
        image_width_height: "",
      }

      //fprmdata
      const formData = new FormData()
      formData.append("guests_font_size", "30")
      formData.append("guests_position_x", "160")
      formData.append("guests_position_y", "160")
      formData.append("guests_width_height", "60")
      formData.append("image_width_height", "360")
      formData.append("qr_position_x", "100")

      formData.append("qr_position_y", "100")
      formData.append("qr_width_height", "100")
      ////used onece
      formData.append("name", dateInSecondsString)
      formData.append(
        "outside_image",
        numberOutSideToggle.toString() == "true" ? "1" : "0",
      )
      formData.append(
        "remove_logo",
        toggleRemoveLogo.toString() == "true" ? "1" : "0",
      )
      formData.append("guest_type", chooseType ? chooseType : "name")
      formData.append("name", dateInSecondsString)

      ////qr code managment
      formData.append("qr_color_code", RgbToHex(selectedColor))
      formData.append(
        "qr_size",
        Number(Number(qrSize) / Number(imageContainerWidth)).toFixed(8),
      )
      formData.append(
        "x_qr",
        Number(Number(qrPosition?.x) / Number(imageContainerWidth)).toFixed(8),
        // .toString(),
      )
      formData.append(
        "y_qr",
        (Number(Number(qrPosition?.y)) / Number(imageContainerHeight)).toFixed(
          8,
        ),
        // .toString(),
      )

      ///name managment
      formData.append("name_color", RgbToHex(selectedColorName))
      formData.append("font_type", selectedFont?.name)
      formData.append("name_size", Number(nameSize).toFixed(0))
      formData.append(
        "name_position_x",
        Number(Number(namePosition?.x) / Number(imageContainerWidth)).toFixed(
          8,
        ),
      )
      formData.append(
        "name_position_y",
        Number(Number(namePosition?.y) / Number(imageContainerHeight)).toFixed(
          8,
        ),
      )
      ////logo managament
      formData.append(
        "logo_position_x",
        Number(Number(logoPosition?.x) / Number(imageContainerWidth)).toFixed(
          8,
        ),
      )
      formData.append(
        "logo_position_y",
        Number(Number(logoPosition?.y) / Number(imageContainerHeight)).toFixed(
          8,
        ),
      )
      formData.append("image_height", imageContainerHeight.toString())
      formData.append("image_width", imageContainerWidth.toString())
      formData.append("image", data.image[0])

      ///form data enbd

      // Step 2: Prepare and send event creation totalData
      if (!currentEventCreated || currentEventCreated == null) {
        const eventRes: any = await api.events.createEvent(eventValues)
        if (eventRes.status === 200) {
          setCurrentEventCreated(eventRes?.data?.data)

          const eventId = eventRes.data.data.event_id
          const now = new Date()
          const eventCodeDesign = await api.events.sendQrDesign(formData)
          // Step 2: Set event qrc code  using
          if (eventCodeDesign.status == 200) {
            let updateEvent = {
              ...eventValues,
              qr_code_design_id: eventCodeDesign?.data?.id,
              event_id: eventId,
              allow_to_add_invitation_to_wallets: 0,
            }
            const eventRes: any = await api.events.createEvent(updateEvent)
            if (eventRes.status === 200) {
              try {
                // const generateRandomPhone = () => {
                //   const randomPart = Math.floor(
                //     100000 + Math.random() * 900000,
                //   ) // Generate a 6-digit number
                //   return `${randomPart}00` // Append "00" to make it an 8-digit number
                // }

                // const formattedNames = [
                //   {
                //     first_name: generateRandomPhone(),
                //     last_name: "",
                //     suffix: "Mr",
                //     email: generateRandomPhone(),
                //     phone: generateRandomPhone(),
                //     quantity_members: "1",
                //   },
                // ]

                const generateRandomPhone = () => {
                  const randomPart = Math.floor(10000 + Math.random() * 90000) // Generate a 5-digit number
                  return `${randomPart}001` // Append "00" to make it an 8-digit number
                }
                const random = generateRandomPhone()
                const formattedNames = [
                  {
                    first_name: random,
                    last_name: random,
                    suffix: "Mr",
                    email: "",
                    phone: random,
                    quantity_members: "1",
                  },
                ]
                const totalData = {
                  event_id: eventId,
                  contacts: formattedNames,
                }
                const contactAdded: any = await api?.contacts?.addGuest(
                  totalData,
                )

                dispatch(getBalance()).then((data) => {
                  console.log("data added")
                })
                setLoading(false)

                navigate(`/invite-details/${eventId}`, {
                  state: { from: "/add-invite" },
                })
              } catch (err: any) {
                setLoading(false)
                // const message = err?.response?.data?.message
                //   ? err?.response?.data?.message
                //   : "Error while adding guests"
                // toast.error(message)

                navigate(`/invite-details/${eventId}`, {
                  state: { from: "/add-invite" },
                })
              }
              // toast.success("Event update successfully")
            }
          } else {
            setLoading(false)
            toast.error("Error while creating  qr code  design")
            setTimeout(() => {
              navigate(`/`)
            }, 2000)
            // toast.error("Event update error")
          }
        }
      } else {
        // const eventRes: any = await api.events.createEvent(eventValues)
        const eventId = currentEventCreated?.event_id
        // setCurrentEventCreated(eventRes?.data?.data)
        // const eventId = eventRes.data.data.event_id
        const eventCodeDesign = await api.events.sendQrDesign(formData)
        // Step 2: Set event qrc code  using

        if (eventCodeDesign.status == 200) {
          let updateEvent = {
            ...eventValues,
            qr_code_design_id: eventCodeDesign?.data?.id,
            event_id: eventId,
            allow_to_add_invitation_to_wallets: 0,
          }
          const eventRes: any = await api.events.createEvent(updateEvent)

          if (eventRes.status === 200) {
            setCurrentEventCreated(eventRes?.data?.data)
            try {
              const generateRandomPhone = () => {
                const randomPart = Math.floor(10000 + Math.random() * 90000) // Generate a 5-digit number
                return `${randomPart}001` // Append "00" to make it an 8-digit number
              }
              const random = generateRandomPhone()
              const formattedNames = [
                {
                  first_name: random,
                  last_name: "",
                  suffix: "Mr",
                  email: "",
                  phone: random,
                  quantity_members: "1",
                },
              ]
              const totalData = {
                event_id: eventId,
                contacts: formattedNames,
              }
              const contactAdded: any = await api?.contacts?.addGuest(totalData)

              setLoading(false)
              dispatch(getBalance()).then((data) => {
                console.log("data added")
              })
              navigate(`/invite-details/${eventId}`, {
                state: { from: "/add-invite" },
              })
            } catch (err: any) {
              setLoading(false)
              // const message = err?.response?.data?.message
              //   ? err?.response?.data?.message
              //   : "Error while adding guests"
              // toast.error(message)

              navigate(`/invite-details/${eventId}`, {
                state: { from: "/add-invite" },
              })
            }
            // toast.success("Event update successfully")
          }
        }

        // dispatch(setQrCodeDesignResponse(eventCodeDesign?.data))
      }
      setLoading(false)
    } catch (err: any) {
      console.log("err", err)
      const message = err?.response?.data?.message
        ? err?.response?.data?.message
        : "Error while creating event  , try gain later please"

      toast.error(message)
      setLoading(false)
      setTimeout(() => {
        // navigate(`/`)
      }, 2000)
      // toast.error("Error while sending the  event")
    }
  }
  const handleSubmitFormNaming = async () => {
    try {
      setLoading(true)

      const currentDate = new Date()
      // Convert the date to seconds (Unix timestamp)
      const dateInSeconds = Math.floor(currentDate.getTime() / 1000)
      // Convert the timestamp to a string
      const dateInSecondsString = dateInSeconds.toString()
      // setSteps("whatsapNumber")
      const formatDate = moment(new Date()).format("Y-MM-DD")
      const formatTime = moment(new Date()).format("HH:mm")
      const eventValues = {
        source: "invite_smart",
        guestType: chooseType,
        orientation: "v",
        name: totalData?.eventName,
        simplified: true,
        host_name: "host",
        event_created_date: formatDate,
        event_created_time: formatTime,
        address: {
          address: "Unknown",
          lat: "24.7136",
          lng: "46.6753",
        },
        text_style: {
          font_family: "Oxygen, sans-serif",
          font_size: "2x 1",
          font_style: {
            textBold: false,
            textItalic: false,
            textUnderline: false,
          },
          color: "#000",
          text_align: "center",
        },
        text_position: "flex-start",
        // start_datetime: dayjs
        //   .utc(totalData?.start_datetime)
        //   .format("YYYY-MM-DD HH:mm:ss"),
        venue: "",
        language: "ar",
        // type: totalData?.eventType,
        image_id: imageId, // Use the uploaded imageId here
        invitation_show_qr_code: true,
        guests_position_x: "",
        guests_position_y: "",
        guests_width_height: "",
        qr_position_x: "",
        qr_position_y: "",
        qr_width_height: "",
        image_width_height: "",
      }
      //fprmdata
      const formData = new FormData()
      formData.append("guests_font_size", "30")
      formData.append("guests_position_x", "160")
      formData.append("guests_position_y", "160")
      formData.append("guests_width_height", "60")
      formData.append("image_width_height", "360")
      formData.append("qr_position_x", "100")
      formData.append("qr_position_y", "100")
      formData.append("qr_width_height", "100")

      ////used onece
      formData.append("name", dateInSecondsString)
      formData.append(
        "outside_image",
        numberOutSideToggle.toString() == "true" ? "1" : "0",
      )
      formData.append(
        "remove_logo",
        toggleRemoveLogo.toString() == "true" ? "1" : "0",
      )
      /// qr code managment
      formData.append("qr_color_code", RgbToHex(selectedColor))
      formData.append(
        "qr_size",
        Number(Number(qrSize) / Number(imageContainerWidth)).toFixed(8),
      )
      formData.append(
        "x_qr",
        Number(Number(qrPosition?.x) / Number(imageContainerWidth)).toFixed(8),
        // .toString(),
      )
      formData.append(
        "y_qr",
        (Number(Number(qrPosition?.y)) / Number(imageContainerHeight)).toFixed(
          8,
        ),
        // .toString(),
      )

      ///name management
      formData.append("name_color", RgbToHex(selectedColorName))
      formData.append("font_type", selectedFont?.name)
      formData.append(
        "name_size",
        Number(Number(nameSize) / Number(imageContainerWidth)).toFixed(8),
      )
      formData.append(
        "name_position_x",
        Number(Number(namePosition?.x) / Number(imageContainerWidth)).toFixed(
          8,
        ),
      )
      formData.append(
        "name_position_y",
        Number(Number(namePosition?.y) / Number(imageContainerHeight)).toFixed(
          8,
        ),
      )

      // logo management
      formData.append(
        "logo_position_x",
        Number(Number(logoPosition?.x) / Number(imageContainerWidth)).toFixed(
          8,
        ),
      )
      formData.append(
        "logo_position_y",
        Number(Number(logoPosition?.y) / Number(imageContainerHeight)).toFixed(
          8,
        ),
      )

      formData.append("guest_type", chooseType ? chooseType : "name")
      formData.append("image_height", imageContainerHeight.toString())
      formData.append("image_width", imageContainerWidth.toString())
      formData.append("image", totalData.image[0])

      // Step 2: Prepare and send event creation totalData

      if (!currentCreatedEvent || currentCreatedEvent == null) {
        const eventRes: any = await api.events.createEvent(eventValues)
        if (eventRes.status === 200) {
          setCurrentEventCreated(eventRes?.data?.data)
          const eventId = eventRes.data.data.event_id

          // Log the FormData (for debugging)

          const eventCodeDesign = await api.events.sendQrDesign(formData)

          // Step 2: Set event qrc code  using

          if (eventCodeDesign.status == 200) {
            let updateEvent = {
              ...eventValues,
              qr_code_design_id: eventCodeDesign?.data?.id,
              event_id: eventId,
              allow_to_add_invitation_to_wallets: 0,
            }
            const eventRes: any = await api.events.createEvent(updateEvent)

            if (eventRes.status === 200) {
              let startingPhoneNumber =
                Math.floor(100000 + Math.random() * 900000) * 100 // Ends with '00'

              const namesArray = namesInput
                .split(/\s*[,;|\n]\s*/g) // Split by comma, semicolon, or new line, allowing optional spaces
                .map((name) => name.trim())
                .filter((name) => name !== "") // Filter out any empty names
              const formattedNames: any = namesArray.map(
                (name: any, index: number) => ({
                  first_name: name ? name : "",
                  last_name: "",
                  suffix: "Mr",
                  email: "",
                  phone: (startingPhoneNumber + index).toString(), // Increment the phone number
                  quantity_members: "1",
                }),
              )

              const totalData = {
                event_id: eventId,
                contacts: formattedNames,
              }
              try {
                const contactAdded: any = await api?.contacts?.addGuest(
                  totalData,
                )
                dispatch(getBalance()).then((data) => {
                  console.log("data added")
                })
                navigate(`/invite-details/${eventId}`, {
                  state: { from: "/add-invite" },
                })
              } catch (err: any) {
                // const message = err?.response?.data?.message
                //   ? err?.response?.data?.message
                //   : "Error while adding contacts , try gain later please"
                // toast.error(message)
                dispatch(getBalance()).then((data) => {
                  console.log("data added")
                })
                setLoading(false)

                navigate(`/invite-details/${eventId}`, {
                  state: { from: "/add-invite" },
                })
              }
              // toast.success("Event update successfully")
            }
          } else {
            toast.error("Event update error")
            setTimeout(() => {
              navigate(`/`)
            }, 2000)
          }
        }
      } else {
        // formData.append("id", qrCodeDesignResponse?.id)
        const eventId = currentEventCreated?.event_id
        const eventCodeDesign = await api.events.sendQrDesign(formData)
        if (eventCodeDesign.status == 200) {
          let updateEvent = {
            ...eventValues,
            qr_code_design_id: eventCodeDesign?.data?.id,
            event_id: eventId,
            allow_to_add_invitation_to_wallets: 0,
          }
          const eventRes: any = await api.events.createEvent(updateEvent)

          if (eventRes.status === 200) {
            const namesArray = namesInput
              .split(/\s*[,;|\n]\s*/g) // Split by comma, semicolon, or new line, allowing optional spaces
              .map((name) => name.trim())
              .filter((name) => name !== "") // Filter out any empty names
            const formattedNames: any = namesArray.map((name: any) => ({
              first_name: name ? name : "",
              last_name: "",
              suffix: "Mr",
              email: "",
              phone: name,
              quantity_members: "1",
            }))

            const totalData = {
              event_id: eventId,
              contacts: formattedNames,
            }
            try {
              const contactAdded: any = await api?.contacts?.addGuest(totalData)
              navigate(`/invite-details/${eventId}`, {
                state: { from: "/add-invite" },
              })

              dispatch(getBalance()).then((data) => {
                console.log("data added")
              })
            } catch (err: any) {
              setLoading(false)

              // const message = err?.response?.data?.message
              //   ? err?.response?.data?.message
              //   : "Error while adding contacts , try gain later please"
              // toast.error(message)

              navigate(`/invite-details/${eventId}`)
            }
            // toast.success("Event update successfully")
          } else {
            navigate(`/invite-details/${eventId}`, {
              state: { from: "/add-invite" },
            })
          }
        } else {
          toast.error("Event While creating event")
        }
      }
      setLoading(false)
      // setActivePage("addNames")
    } catch (err: any) {
      setLoading(false)
      const message = err?.response?.data?.message
        ? err?.response?.data?.message
        : "Error while creating  contacts , try gain later please"
      toast.error(message)
      setTimeout(() => {
        navigate(`/`)
      }, 2000)
      // setTimeout(() => {
      //   navigate(`/`)
      // }, 3000)

      // toast.error("Error while sending the  event")
    } finally {
      setLoading(false)
    }
  }
  /////validate the name
  // const validateAndUpdatePosition = () => {
  //   if (uploadedImageRef.current && nameLabelRef.current) {
  //     const imageRect = uploadedImageRef.current.getBoundingClientRect()
  //     const labelRect = nameLabelRef.current.getBoundingClientRect()

  //     let newX = namePosition.x
  //     let newY = namePosition.y

  //     // Constrain X position
  //     if (newX < 0) newX = 0
  //     if (newX + labelRect.width > imageRect.width) {
  //       newX = imageRect.width - labelRect.width
  //     }
  //     // Constrain Y position
  //     if (newY < 0) newY = 0
  //     if (newY + labelRect.height > imageRect.height) {
  //       newY = imageRect.height - labelRect.height
  //     }

  //     if (newX !== namePosition.x || newY !== namePosition.y) {
  //       setNamePosition({ x: newX, y: newY })
  //     }
  //   }
  // }
  // // Update label dimensions when size or font changes
  // useEffect(() => {
  //   if (nameLabelRef.current) {
  //     const { offsetWidth, offsetHeight } = nameLabelRef.current
  //     setLabelDimensions({ width: offsetWidth, height: offsetHeight })

  //     // Ensure position is within bounds after size change
  //     validateAndUpdatePosition()
  //   }
  // }, [nameSize, selectedFont])

  ////update  the position of the qr code size, qr position and logo position when the size of the container have references

  return (
    <>
      {loading ? (
        <LoaderLight />
      ) : (
        <>
          {active == "eventFrom" && (
            <div className="container">
              <div className="mb-3  " style={{ width: "80px" }}>
                <Button
                  className="d-flex align-items-center "
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    color: "black",
                    fontSize: "18px",
                    textDecoration: "none",
                    textTransform: "none",
                  }}
                  onClick={() => navigate(-1)}
                >
                  <IconArrowLeft />
                  <span className="reminders-page__link-text">
                    {t("buttons.backNew")}
                  </span>
                </Button>
              </div>{" "}
              <div className=" d-flex justify-content-between">
                <h5 className="mb-3 fs-3 fw-bold">
                  {" "}
                  {t("invitation.addInvitation")}
                </h5>{" "}
              </div>
              <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                  {/* <div className="d-flex flex-column flex-md-row gap-4 "> */}
                  <div
                    className="container  w-full d-flex  flex-column flex-md-row gap-4 mb-3 "
                    // style={{ backgroundColor: "yellow" }}
                  >
                    <div
                      style={{ height: "auto" }}
                      className=" col-12 col-md-6  top-0  align-items-top d-flex flex-column  gap-2"
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          padding: "25px",
                          // margin: "20px",
                          width: "100%",
                          borderRadius: "15px",
                          backgroundColor: "white",
                        }}
                        className="d-flex justify-content-center align-items-center"
                      >
                        <div
                          ref={uploadedImageRef}
                          // id="image-container"
                          style={{
                            // backgroundColor: "grey",
                            position: "relative",
                            // width: imageContainerWidth,
                            // height: imageContainerHeight,
                            // border: "1px solid  #dedede",
                            // height: "auto",
                            // width: "100%",
                            // overflow: "hidden",
                            // minHeight: "50px",
                          }}
                          className="d-flex align-items-center justify-content-center"
                        >
                          {/* <div className=" mb-4 "> */}{" "}
                          <ImageInputNew
                            name="image"
                            label="Upload Image"
                            placeholder="Drag or select an image"
                            imageUrl={
                              currentImageUrl && !currentImageUrl == null
                                ? currentImageUrl
                                : ""
                            }
                            setColor={handleSetColors} // Passing setColors function as prop
                            setImageRef={handleSetImageRef}
                          />
                          <div className="mt-0">
                            {/* </div> qr ,logo and name design  */}
                            {!numberOutSideToggle &&
                              formValues?.image?.length > 0 && (
                                <>
                                  {/* Draggable QR Code */}
                                  <OverlayTrigger
                                    placement="top" // Tooltip position (top, bottom, left, right)
                                    overlay={
                                      <Tooltip id="name-tooltip">
                                        {t(
                                          "invitation.dragToMoveTheQrCodeAndClickToChangeTheSize",
                                        )}
                                      </Tooltip> // Tooltip content
                                    }
                                  >
                                    <div
                                      ref={qrDivRef}
                                      className="d-flex  flex-column gap-0 align-items-center"
                                      draggable={true} // Enable dragging if required
                                      onDragStart={handleDragStart}
                                      onDrag={handleDrag}
                                      onDragEnd={handleDragEnd} // Save position on drag end
                                      onTouchStart={handleTouchStart}
                                      onTouchMove={handleTouchMove}
                                      style={{
                                        position: "absolute",
                                        top: `${qrPosition.y}px`,
                                        left: `${qrPosition.x}px`,
                                      }}
                                      onClick={() => setShowQrSize(!showQrSize)}
                                    >
                                      <QRGenerator
                                        value={qrValue}
                                        // bgColor={RgbToHex(selectedColor)}
                                        bgColor={RgbToHex(selectedColor)}
                                        size={qrSize}
                                        // color={RgbToHex(selectedColor)}
                                      />
                                    </div>
                                  </OverlayTrigger>
                                  {/* Draggable name  */}
                                  <OverlayTrigger
                                    placement="top" // Tooltip position (top, bottom, left, right)
                                    overlay={
                                      <Tooltip id="name-tooltip">
                                        {t(
                                          "invitation.dragToMoveTheNameOrNumberAndClickToChangeTheSize",
                                        )}
                                      </Tooltip> // Tooltip content
                                    }
                                  >
                                    <div
                                      ref={nameDivRef}
                                      className="d-flex  flex-column gap-0 align-items-center"
                                      draggable={true} // Enable dragging if required
                                      onDragStart={handleDragStartName}
                                      onDrag={handleDragName}
                                      onDragEnd={handleDragEndName} // Save position on drag end
                                      onTouchStart={handleTouchStartName}
                                      onTouchMove={handleTouchMoveName}
                                      style={{
                                        position: "absolute",
                                        top: `${namePosition.y}px`,
                                        left: `${namePosition.x}px`,
                                        cursor: "move",
                                        // width: `${labelDimensions.width}px`,
                                      }}
                                      onClick={() =>
                                        setShowNameSize(!showNameSize)
                                      }
                                    >
                                      <div ref={nameLabelRef}>
                                        <NameLabel
                                          label={t("invitation.nameOrNumber")}
                                          color={RgbToHex(selectedColorName)}
                                          size={nameSize}
                                          font={selectedFont?.fontFamily}
                                        />
                                      </div>
                                    </div>
                                  </OverlayTrigger>
                                  {/* Draggable Logo */}
                                  {!toggleRemoveLogo && (
                                    <OverlayTrigger
                                      placement="top" // Tooltip position (top, bottom, left, right)
                                      overlay={
                                        <Tooltip id="name-tooltip">
                                          {t("invitation.dragToMoveTheLogo")}
                                        </Tooltip> // Tooltip content
                                      }
                                    >
                                      <img
                                        ref={logoDivRef}
                                        src={InvitesmartLogonew}
                                        alt="Invite Smart Logo"
                                        style={{
                                          position: "absolute",
                                          // top: "2px",
                                          // right: "5px",
                                          top: `${logoPosition.y}px`,
                                          left: `${logoPosition.x}px`,
                                          height: "60px",
                                          width: "70px",
                                          objectFit: "contain",
                                        }}
                                        draggable={true} // Enable dragging if required
                                        onDragStart={handleDragStartLogo}
                                        onDrag={handleDragLogo}
                                        onDragEnd={handleDragEndLogo} // Save position on drag end
                                        onTouchStart={handleTouchStartLogo}
                                        onTouchMove={handleTouchMoveLogo}
                                      />
                                    </OverlayTrigger>
                                  )}
                                </>
                              )}{" "}
                          </div>
                        </div>

                        {/* qr code design out sde the image */}
                        <div style={{ width: "340px" }}>
                          {formValues?.image?.length > 0 && (
                            <>
                              {/* draggable  image and logo */}
                              {numberOutSideToggle && (
                                <div
                                  style={{
                                    height: "100px",
                                    backgroundColor: "white ",
                                    // marginBottom: "10px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    // padding: numberOutSideToggle ? "15px" : "0px",
                                    // paddingTop: "10px",
                                    alignItems: "bottom ",
                                  }}
                                >
                                  <div className="d-flex flex-row gap-2 mb-1 align-items-end justify-content-center">
                                    <QRGenerator
                                      value={qrValue}
                                      // bgColor={RgbToHex(selectedColor)}
                                      bgColor={RgbToHex(selectedColor)}
                                    />

                                    <div className="mb-2">
                                      <NameLabel
                                        label={t("invitation.nameOrNumber")}
                                        color={RgbToHex(selectedColorName)}
                                        size={nameSize}
                                        font={selectedFont?.fontFamily}
                                      />
                                    </div>
                                  </div>

                                  <div className="mb-3 d-flex flex-row gap-2 align-items-end justify-content-center">
                                    {!toggleRemoveLogo && (
                                      <img
                                        src={InvitesmartLogonew}
                                        style={{
                                          height: "60px",
                                          width: "70px",
                                          objectFit: "contain",
                                          display: "flex",
                                          alignItems: "bottom",
                                        }}
                                        alt=""
                                      />
                                    )}
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                      <div>
                        {" "}
                        {/* color selction for qr code */}
                        {formValues?.image?.length > 0 ? (
                          <div
                            style={{
                              minHeight: "90px",
                              backgroundColor: "white ",
                            }}
                            className="px-3 pb-2 mt-3 d-flex flex-column  gap-2 rounded-3 shadow-sm"
                            //   className="rounded-3 shadow-sm p-4 me-3 ms-auto bottom-0 align-items-start d-flex justify-content-between gap-3"
                          >
                            <h5
                              className="d-flex flex-row align-items-center ps-0 pt-2"
                              style={{
                                fontSize: "1rem",
                                backgroundColor: "#ffffff",
                              }}
                            >
                              {t("invitation.availableColorsForQrCode")}
                            </h5>

                            <div
                              style={{
                                flexWrap: "nowrap",
                                overflowX: "auto",
                                maxWidth: "96%",
                                whiteSpace: "nowrap",
                                scrollbarWidth: "thin",
                                scrollbarColor: "#888 #f1f1f1",
                                padding: "7px",
                                backgroundColor: "#eaeaea",
                                borderRadius: "10px",
                              }}
                            >
                              {premium == 1 ? (
                                <ColorPickerQrCode
                                  colors={colors}
                                  setColor={setSelectedColor}
                                />
                              ) : (
                                <>
                                  <ColorPickerUnPremium
                                    colors={colors}
                                    setColor={setSelectedColor}
                                    // onColorClick={() =>
                                    //   handleOpenUpgrade("colors")
                                    // }
                                    onColorClick={handleChangeColor}
                                  />
                                </>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div
                            style={{
                              height: "100px",
                              backgroundColor: "white ",
                            }}
                            className="px-3 py-2 mt-1 d-flex flex-column  gap-2 rounded-3 shadow-sm"
                            //   className="rounded-3 shadow-sm p-4 me-3 ms-auto bottom-0 align-items-start d-flex justify-content-between gap-3"
                          >
                            <DisabledColors
                              title={t("invitation.availableColorsForQrCode")}
                            />
                          </div>
                        )}
                      </div>
                      <div>
                        {" "}
                        {formValues?.image?.length > 0 ? (
                          <div
                            style={{
                              minHeight: "90px",
                              backgroundColor: "white ",
                            }}
                            className="px-3 pb-2 mt-2 d-flex flex-column  gap-2 rounded-3 shadow-sm"
                            //   className="rounded-3 shadow-sm p-4 me-3 ms-auto bottom-0 align-items-start d-flex justify-content-between gap-3"
                          >
                            <h5
                              className="d-flex flex-row align-items-center ps-0 pt-2"
                              style={{
                                fontSize: "1rem",
                                backgroundColor: "#ffffff",
                              }}
                            >
                              {t("invitation.availableColorsForNameOrNumber")}

                              {/* {t("invitation.fonts")} */}
                            </h5>
                            <div
                              style={{
                                flexWrap: "nowrap",
                                overflowX: "auto",
                                maxWidth: "96%",
                                whiteSpace: "nowrap",
                                scrollbarWidth: "thin",
                                scrollbarColor: "#888 #f1f1f1",
                                padding: "7px",
                                backgroundColor: "#eaeaea",
                                borderRadius: "10px",
                              }}
                            >
                              {premium == 1 ? (
                                <ColorPicker
                                  colors={colors}
                                  setColor={setSelectedColorName}
                                />
                              ) : (
                                <>
                                  {/*                                  
                                <ColorPickerPremium
                                  colors={colors}
                                  setColor={setSelectedColor}
                                /> */}
                                  <ColorPickerUnPremium
                                    colors={colors}
                                    setColor={setSelectedColorName}
                                    // onColorClick={() =>
                                    //   handleOpenUpgrade("colors")
                                    // }
                                    onColorClick={handleChangeColor}
                                  />
                                </>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div
                            style={{
                              height: "100px",
                              backgroundColor: "white ",
                            }}
                            className="px-3 py-2 d-flex flex-column  gap-2 rounded-3 shadow-sm"
                            //   className="rounded-3 shadow-sm p-4 me-3 ms-auto bottom-0 align-items-start d-flex justify-content-between gap-3"
                          >
                            <DisabledColors
                              title={t(
                                "invitation.availableColorsForNameOrNumber",
                              )}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    {/* right end */}
                    <div
                      className="col-12 col-md-5  gap-3 mt-4"
                      style={{
                        // backgroundColor: "#F7F5F5",
                        // backgroundColor: "blue",

                        display: "flex",
                        flexDirection: "column",
                        // gap: "3px",
                        marginLeft: "auto",
                      }}
                    >
                      {/* name text field */}
                      <div
                        style={{
                          height: "60px",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <StringInput
                          name="eventName"
                          label={t("invitation.inviteName")}
                          placeholder={t("invitation.addInvitationText")}
                        />
                      </div>
                      {/* font selection  for name*/}
                      <div>
                        {" "}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "7px",
                            alignItems: "center",
                            height: "80px",
                            borderRadius: "10px",
                            backgroundColor: "#ffffff",
                          }}
                        >
                          <h5
                            className="d-flex flex-row align-items-center mb-3 ps-3"
                            style={{
                              fontSize: "1rem",
                              backgroundColor: "#ffffff",
                            }}
                          >
                            {t("invitation.fonts")}
                          </h5>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "10px",
                              flexWrap: "nowrap",
                              overflowX: "auto",
                              maxWidth: "78%",
                              whiteSpace: "nowrap",
                              scrollbarWidth: "thin",
                              scrollbarColor: "#888 #f1f1f1",
                              paddingBottom: "10px",
                            }}
                          >
                            {premium == 1 ? (
                              <FontPicker
                                fonts={fonts}
                                selectedFont={selectedFont}
                                setFont={setSelectedFont}
                              />
                            ) : (
                              <>
                                <FontPickerUnPremium
                                  fonts={fonts}
                                  selectedFont={selectedFont}
                                  setFont={setSelectedFont}
                                  onColorClick={handleChangeFont}
                                  // onColorClick={() =>
                                  //   handleOpenUpgrade("fonts")
                                  // }
                                />
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* color selection  for name*/}

                      {/* name of number out side the image choise */}
                      <div
                        style={{
                          height: "80px",
                          display: "flex",
                          backgroundColor: "#ffffff",
                          alignItems: "center",
                        }}
                        className="px-3 py-2  gap-2 rounded-3 shadow-sm"
                      >
                        <h5 className="" style={{ fontSize: "1rem" }}>
                          {t("invitation.nameOrNumberOutSideTheImage")}
                        </h5>
                        <div
                          className={`${styles.switchPoint} ms-auto  switch`}
                        >
                          {" "}
                          <Switch
                            onChange={() =>
                              setNumberOutSideToggle(!numberOutSideToggle)
                            } // Dispatch the action
                            checked={numberOutSideToggle}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            boxShadow="0px"
                            activeBoxShadow="0px"
                            width={60}
                            height={28}
                            handleDiameter={24}
                            onColor="#477BFF" // Background color when checked (on)
                            // offColor="#FF5722" // Background color when unchecked (off)
                            onHandleColor="#FFFFFF" // Handle color when checked
                            offHandleColor="#FFFFFF" // Handle color when unchecked
                          />
                        </div>
                      </div>
                      {/* remove logo choice */}
                      <div
                        style={{
                          height: "80px",
                          display: "flex",
                          backgroundColor: "#ffffff",
                          alignItems: "center",
                        }}
                        className="px-3 py-2  gap-2 rounded-3 shadow-sm"
                      >
                        <h5 className="" style={{ fontSize: "1rem" }}>
                          {t("invitation.removeLogo")}
                        </h5>
                        <div
                          className={`${styles.switchPoint} ms-auto  switch`}
                        >
                          {" "}
                          <div
                            style={{ position: "relative" }}
                            // onClick={() => {
                            //   handleOpenUpgrade("Logo removal")
                            // }}
                          >
                            {premium == 1 ? (
                              <Switch
                                // onChange={() =>
                                //   setToggleRemoveLogo(!toggleRemoveLogo)
                                // }
                                onChange={handleChangeLogoRemoval}
                                checked={toggleRemoveLogo}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px"
                                activeBoxShadow="0px"
                                width={60}
                                height={28}
                                handleDiameter={24}
                                onColor="#477BFF" // Background color when checked (on)
                                disabled={false} // First switch is disabled
                              />
                            ) : (
                              <>
                                <div
                                  style={{
                                    position: "relative",
                                    width: 60,
                                    height: 28,
                                  }}
                                  // onClick={() => {
                                  //   handleOpenUpgrade("logo_removal")
                                  // }}
                                  onClick={handleChangeLogoRemoval}
                                >
                                  <Switch
                                    // onChange={() =>
                                    //   handleOpenUpgrade("logo_removal")
                                    // }
                                    onChange={handleChangeLogoRemoval}
                                    checked={toggleRemoveLogo}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    boxShadow="0px"
                                    activeBoxShadow="0px"
                                    width={60}
                                    height={28}
                                    handleDiameter={24}
                                    onColor="#477BFF"
                                    disabled={true}
                                  />
                                  <span
                                    style={{
                                      position: "absolute",
                                      top: "50%",
                                      left: "20%",
                                      transform: "translate(-50%, -50%)",
                                      pointerEvents: "none", // Prevent interaction with the icon
                                      fontSize: "18px", // Adjust icon size as needed
                                      color: "black",
                                    }}
                                  >
                                    <MdLock />
                                  </span>
                                </div>
                              </>
                            )}

                            <div
                              style={{
                                position: "absolute",
                                top: "-5px",
                                left: "6px",
                                bottom: "5px",
                              }}
                              // onClick={() => {
                              //   handleOpenUpgrade("Logo removal")
                              // }}
                            ></div>
                          </div>
                        </div>
                      </div>

                      <div>
                        <button
                          type="submit"
                          // onClick={(e) => onSubmit(e, "")}
                          className="btn btn-dark"
                          // onClick={handleSubmitNumber}
                          style={{
                            marginTop: "auto",
                            marginLeft: "auto",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "60px",
                            borderRadius: "5px",
                            backgroundColor: "#20529B",
                          }} // Ensure it sticks to the bottom
                        >
                          {/* {t("buttons.next")} */}
                          Generate Invite
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </FormProvider>
            </div>
          )}

          {/* steps */}

          {active == "activeChooseType" && (
            <>
              <div className="container">
                <div className="mb-3 " style={{ width: "80px" }}>
                  <Button
                    className="d-flex align-items-center "
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      color: "black",
                    }}
                    // onClick={() => setActivePage("addInvitation")}
                    // onClick={() => setActive("eventFrom")}
                    onClick={() => navigate("/")}
                  >
                    <IconArrowLeft />
                    <span className="reminders-page__link-text">
                      {t("buttons.backNew")}
                    </span>
                  </Button>
                </div>{" "}
                <div className="mb-4 d-flex justify-content-between">
                  <h5 className="mb-3 fs-3 fw-normal">
                    {t("invitation.chooseType")}
                  </h5>
                </div>
                <div className="container d-flex  flex-column   flex-md-row  gap-4 mb-3 ">
                  <div className=" col-12 col-md-2  top-0  align-items-top d-flex justify-content-center  gap-1">
                    <FaCaretRight />{" "}
                    <h5
                      style={{
                        width: "230px",
                        maxHeight: "200px",
                        padding: "10px",
                        border: "2px solid white",
                        color: "#6D717A",
                        textTransform: "capitalize", // Capitalizes the first letter of each word
                      }}
                    >
                      {t(
                        "invitation.chooseYourInvitationStyleByNameOrNumberForAQuickAndPersonalizedSelection",
                      )}
                    </h5>
                  </div>
                  <div className="col-12 col-md-8 col-lg-6 d-flex flex-column  top-0  align-items-top d-flex justify-content-center  ">
                    <div
                      className="d-flex flex-column flex-md-row f gap-2 "
                      style={{ marginLeft: "auto" }}
                    >
                      <div className="d-none d-md-flex flex-column   col-12 col-md-4 gap-2 align-items-end ">
                        <img
                          src={
                            chooseType === "name"
                              ? chooseTypeName
                              : chooseTypeNumber
                          }
                          style={{ width: "130px", height: "145px" }}
                          alt="image"
                        />{" "}
                        <img
                          style={{ width: "130px", height: "145px" }}
                          src={
                            chooseType === "name"
                              ? chooseTypeName
                              : chooseTypeNumber
                          }
                          alt="image"
                        />
                      </div>
                      <div className=" col-12 col-md-4 align-items-start">
                        <img
                          src={
                            chooseType === "name"
                              ? chooseTypeName
                              : chooseTypeNumber
                          }
                          style={{
                            width: "250px",
                            height: "300px",
                            objectFit: "cover",
                            objectPosition: "center",
                          }}
                          alt="image"
                        />
                      </div>
                    </div>
                    <div className=" d-flex flex-column flex-md-row gap-3 mt-3 ms-auto">
                      {chooseType === "name" && (
                        <>
                          <button
                            type="submit"
                            // onClick={(e) => onSubmit(e, "")}
                            className="btn btn-dark"
                            style={{
                              marginTop: "auto",

                              width: "150px",
                              height: "40px",
                              borderRadius: "5px",
                              backgroundColor: "#20529B",
                              border: "none",
                            }} // Ensure it sticks to the bottom
                            onClick={() => setChooseType("name")}
                          >
                            {t("buttons.name")}
                          </button>
                          <button
                            type="submit"
                            // onClick={(e) => onSubmit(e, "")}
                            className="btn btn-dark shadow-lg fw-bold"
                            style={{
                              marginTop: "auto",
                              width: "150px",
                              height: "40px",
                              borderRadius: "5px",
                              backgroundColor: "white",
                              color: "#20529B",
                              border: "none",
                            }} // Ensure it sticks to the bottom
                            onClick={() => setChooseType("number")}
                          >
                            {t("buttons.number")}
                          </button>
                        </>
                      )}
                      {chooseType === "number" && (
                        <>
                          <button
                            type="submit"
                            // onClick={(e) => onSubmit(e, "")}
                            className="btn btn-dark shadow-lg fw-bold"
                            style={{
                              marginTop: "auto",
                              width: "150px",
                              height: "40px",
                              borderRadius: "5px",
                              backgroundColor: "white",
                              color: "#20529B",
                              border: "none",
                            }} // Ensure it sticks to the bottom
                            onClick={() => setChooseType("name")}
                          >
                            {t("buttons.name")}
                          </button>
                          <button
                            type="submit"
                            // onClick={(e) => onSubmit(e, "")}
                            className="btn btn-dark"
                            style={{
                              marginTop: "auto",

                              width: "150px",
                              height: "40px",
                              borderRadius: "5px",
                              backgroundColor: "#20529B",
                              border: "none",
                            }} // Ensure it sticks to the bottom
                            onClick={() => setChooseType("number")}
                          >
                            {t("buttons.number")}
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="container  w-full d-flex  flex-column flex-md-row gap-4 mb-3 ">
                  <button
                    type="submit"
                    // onClick={(e) => onSubmit(e, "")}
                    className="btn btn-dark"
                    style={{
                      width: "150px",
                      height: "40px",
                      borderRadius: "5px",
                      backgroundColor: "#20529B",
                      border: "none",
                      marginLeft: "auto",
                      marginTop: "20px",
                    }} // Ensure it sticks to the bottom
                    // onClick={() => {
                    //   setActivePage("addNames")
                    // }}

                    onClick={handleSubmitForm}
                  >
                    {t("buttons.next")}
                  </button>
                </div>
              </div>
              {/* <ToastContainer
                style={{ width: "90%", maxWidth: "400px", fontSize: "18px" }}
              /> */}
            </>
          )}
          {active == "addNames" && (
            <>
              <form
                className="d-flex flex-column"
                onSubmit={handleSubmitFormNaming}
              >
                <div className="mb-3 " style={{ width: "80px" }}>
                  <Link
                    className="d-flex align-items-center reminders-page__link-container"
                    to="/"
                    // onClick={() => dispatch(resetInvitationState())}
                  >
                    <IconArrowLeft />
                    <span className="reminders-page__link-text">
                      {t("buttons.backNew")}
                    </span>
                  </Link>
                </div>{" "}
                <div className=" d-flex justify-content-between">
                  <h5 className="mb-3 fs-3 fw-bold">
                    {t("invitation.addNames")}
                  </h5>{" "}
                </div>
                <div className="d-flex flex-column justify-content-center align-items-center mt-4 mb-2 pb-2">
                  <h5
                    style={{
                      position: "relative",
                      paddingBottom: "8px", // Adjust for spacing between text and underline
                    }}
                    className="mb-2 pb-2 "
                  >
                    <span className="me-1">{t("invitation.please")}</span>
                    <span className="me-1" style={{ color: "#20529B" }}>
                      {t("invitation.add")}
                    </span>
                    <span className="me-1"> {t("invitation.nameOr")}</span>
                    <span style={{ color: "#20529B" }} className="me-1">
                      {t("invitation.paste")}
                    </span>
                    {t("invitation.themHereSeparateEachGuestNameWithAComma")}
                  </h5>

                  <div
                    className="profile-input  rounded-sm text-dark d-flex -justify-content-center "
                    style={{ width: "70%" }}
                  >
                    <style>
                      {`
      input::placeholder {
        color: #d3d2d2;
        
      }
    `}
                    </style>
                    <textarea
                      required
                      placeholder={t("invitation.addGuestName")}
                      value={namesInput}
                      onChange={(e) => setNamesInput(e.target.value)}
                      style={{
                        color: "#000000", // Text color
                        fontSize: "1rem",
                        paddingLeft: "20px",
                        paddingRight: "10px",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        paddingTop: "20px",
                        paddingBottom: "7px",
                        border: "1px solid #ccc", // Optional: border styling
                        width: "100%",
                        resize: "vertical",
                        //   height: "100px", // Adjust height as needed
                      }}
                      rows={9} // Optional: Controls the default number of rows
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  // onClick={(e) => onSubmit(e, "")}
                  className="btn btn-dark"
                  style={{
                    width: "150px",
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "#20529B",
                    border: "none",
                    marginLeft: "auto",
                    marginTop: "20px",
                  }} // Ensure it sticks to the bottom
                >
                  {t("buttons.next")}
                </button>
              </form>
            </>
          )}
          {active == "addNumbers" && (
            <form
              className="d-flex flex-column gap-4 align-items-center "
              // onSubmit={handleSubmitNumber}
              // style={{ maxWidth: "400px" }}
            >
              <div className="mb-3 " style={{ width: "80px" }}>
                <Link
                  className="d-flex align-items-center reminders-page__link-container"
                  to="/"
                  // onClick={() => dispatch(resetInvitationState())}
                >
                  <IconArrowLeft />
                  <span className="reminders-page__link-text">
                    {t("buttons.backNew")}
                  </span>
                </Link>
              </div>{" "}
              <h5 className=" fs-3 fw-bold">{t("inviteDetail.addGuests")}</h5>{" "}
              <h5
                style={{
                  position: "relative",
                  paddingBottom: "8px", // Adjust for spacing between text and underline
                }}
              >
                {t("inviteDetail.howManyGuestsYouWantToAdd")}
              </h5>
              <input
                type="number"
                value={numberOfGuests}
                onChange={(e: any) =>
                  setNumberOfGuests(Math.max(1, Number(e.target.value)))
                }
                className="form-control"
                min={1}
                style={{ width: "260px" }}
                placeholder="Number of Guests"
              />{" "}
              <button
                type="submit"
                // onClick={(e) => onSubmit(e, "")}
                className="btn btn-dark "
                style={{
                  height: "40px",
                  borderRadius: "5px",
                  backgroundColor: "#20529B",
                  border: "none",
                  width: "260px",
                }} // Ensue it sticks to the bottom
                // disabled={addingGuestLoading}
              >
                {/* {addingGuestLoading ? (
                  <h6 className="p-1">loading...</h6>
                ) : ( */}
                {t("buttons.addGuests")}
                {/* )} */}
              </button>
            </form>
          )}
        </>
      )}

      {/* update qr size */}
      <QRSizeModal
        show={showQrSize}
        onHide={() => setShowQrSize(false)}
        qrValue={qrValue}
        qrSize={qrSize}
        setQrSize={setQrSize}
        selectedColor={selectedColor}
        onConfirm={() => setShowQrSize(false)}
        qrPosition={qrPosition}
        uploadedImageRef={uploadedImageRef}
        qrDivRef={qrDivRef}
        setQrPosition={setQrPosition}
      />
      {/* update name text size */}
      <NameOrNumberSizeModal
        showNameSize={showNameSize}
        onHide={() => setShowNameSize(false)}
        onConfirm={() => setShowNameSize(false)}
        selectedFont={selectedFont}
        nameSize={nameSize}
        setNameSize={setNameSize}
        selectedColorName={selectedColorName}
        // onSizeChange,
        setNamePosition={setNamePosition}
        namePosition={namePosition}
        uploadedImageRef={uploadedImageRef}
        nameDivRef={nameDivRef}
      />

      {/* ///upgrade plan pop up */}
      <UpgradeToPremiumPopup
        show={upgrade}
        onHide={() => setUpgrade(false)}
        upgradesText={upgradesText}
        formValues={formValues}
        currentEventCreated={currentEventCreated}
        setCurrentEventCreated={setCurrentEventCreated}
        type="add"
      />
      {/* add guests */}
      {/* <AddGuestsForNumberModal
        show={showCreateModal}
        onHide={handleCloseCreateModal}
        numberOfGuests={numberOfGuests}
        setNumberOfGuests={setNumberOfGuests}
        handleSubmitNumber={handleSubmitNumber}
      /> */}
    </>
  )
}

export default AddInvitationFrom
